import { useContext, useEffect, memo } from "react";
import { useRouter } from "next/router";

import { GlobalContext } from "@/contexts/GlobalContext";
import { ModalContext } from "@/contexts/ModalsContext";

import VrmSearch from "./VRM.component";
import ManualSearch from "./Search.component";

import useFetch from "@/hooks/useFetchData";

import { TopCats } from "@/interfaces/SharedInterfaces";

import styles from "@/styles/components.module.scss";

const VhInfo = () => {
    const { globalState: { apiUrl, vhInfo, vrmInfo, cats }, dispatchGlobal } = useContext(GlobalContext);
    const { modalState: { forms, showManual }, dispatchModal } = useContext(ModalContext);
    const router = useRouter();
    const { useFetchData } = useFetch();

    useEffect(() => {
        dispatchModal({ type: "HIDE_FORMS" });
    }, [router.pathname]);

    const handleToggleSearchForms = () => {
        dispatchModal({ type: "TOGGLE_FORMS" });
        dispatchModal({ type: "HIDE_MANUAL" });
    };

    useEffect(() => {
        if (vhInfo?.KCODE_B && !cats) {
            fetchTopCats("vehicles/ktype");
        }
    }, [vhInfo?.KCODE_B, cats]);

    const fetchTopCats = async (endpoint: string) => {
        const url: string = `${apiUrl}/${endpoint}${vhInfo?.KCODE_B ? `?ktype=${vhInfo?.KCODE_B}` : ""}`;

        try {
            const result = await useFetchData<TopCats[]>(url);

            if (!result.success) {
                return false;
            }

            dispatchGlobal({ type: "SET_TOP_CATS", cats: result.data });
        } catch (error) {
            console.error(error);
        }
    };

    const handleToggleSearch = () => {
        if (!showManual) {
            dispatchModal({ type: "SHOW_MANUAL" });
            dispatchModal({ type: "SHOW_FORMS" });
        } else {
            dispatchModal({ type: "HIDE_MANUAL" });
        }
    };

    const searchForms = (
        <div className={styles["search-forms"]} >
            {vhInfo && forms &&
                <button 
                    onClick={handleToggleSearchForms} 
                    className={styles["vh-info-close-btn"]} 
                >{!forms ? "Change Vehicle" : "Close"}</button>
            }
            {!showManual && <VrmSearch />}
            {showManual && <ManualSearch />}
            <button 
                className={styles["search-toggle-btn"]} 
                onClick={handleToggleSearch} 
            >{showManual ? "Search Registration" : "Search Manually"}</button>
        </div>
    );

    const vhInfoBox = vhInfo && !forms && router.pathname !== "/cart" ? (
        <div className={styles["vh-info"]}>
            <div className={styles["vh-info-bar"]}>
                <div className={styles["vh-info-box"]}>
                    <div className={styles["vh-info-image"]}>
                        <img
                            src={`${process.env.NEXT_PUBLIC_CDN_URI}/static/logos/vehicles/${vhInfo.MAKE.replace(/\s|-/g, "_")}.png`}
                            alt="vehicle-logo"
                        />
                    </div>

                    <div className={styles["vh-info-fields"]}>
                        <div className={styles["info-fields"]}>
                            <h4 style={{margin: "0"}}>{vhInfo.MAKE}</h4>
                            <span>{vhInfo.MODEL1} {vhInfo.MODEL2} {vhInfo.SUBMODEL ? `- ${vhInfo.SUBMODEL}` : ""}</span>
                            <span>{vhInfo.ENG1} - {vhInfo.FUEL.toUpperCase()}</span>
                        </div>
                        <div className={styles["info-fields"]}>
                            <span>{vhInfo.BODY} - {vhInfo.FROMYR} - {vhInfo.TOYR ? vhInfo.TOYR : new Date().getFullYear()}</span>
                            <span>{vhInfo.KW}KW/{vhInfo.BHP}BHP</span>
                            <span>{vhInfo.DRIVE} - {vhInfo.CYL}CYL/{parseInt(vhInfo.CYL) * parseInt(vhInfo.VALVES)}V</span>
                            <span>{vrmInfo?.chassis_number}</span>
                        </div>
                    </div>
                </div>

                <div className={styles["vh-info-buttons"]}>
                    <button 
                        onClick={handleToggleSearchForms} 
                        className={styles["vh-info-change-btn"]} 
                    >{!forms ? "Change Vehicle" : "Close"}</button>
                </div>
            </div>
        </div>
      ) : searchForms;

    return (
        <div className={styles["vh-bar"]}>
            {vhInfoBox}
        </div>
    );
};

export default memo(VhInfo);
